import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "app-channel-onsite",
  "use": "app-channel-onsite-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"app-channel-onsite\"><path d=\"M7.11 30.009h14.223M.89 23.182c0 1.885 1.592 3.413 3.555 3.413H24c1.963 0 3.555-1.528 3.555-3.413m-26.666 0V11.235c0-1.885 1.592-3.413 3.555-3.413h6.222M.89 23.182h26.666m0 0v-5.191m-8.889 12.018H9.778l.888-3.414h7.111l.89 3.414zM27.378.889H17.6a3.556 3.556 0 00-3.556 3.555v5.334a3.556 3.556 0 003.556 3.555h4.444v4.445l4.445-4.445h.889a3.556 3.556 0 003.555-3.555V4.444A3.556 3.556 0 0027.378.89zm-9.334 5.777a.444.444 0 100 .89.444.444 0 000-.89zm4.445 0a.444.444 0 100 .89.444.444 0 000-.89zm4.444 0a.444.444 0 100 .89.444.444 0 000-.89z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/app-channel-onsite.svg
// module id = MExm
// module chunks = 39 44